import React, { useEffect, useState } from 'react';
import { Play, Pause, RefreshCw } from 'lucide-react';
import { Poem } from '../../types';
type ListenModuleProps = {
  poem: Poem;
};
export function ListenModule({
  poem
}: ListenModuleProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let interval: number;
    if (isPlaying) {
      interval = window.setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) {
            setIsPlaying(false);
            return 0;
          }
          return prev + 0.5;
        });
      }, 50);
    }
    return () => clearInterval(interval);
  }, [isPlaying]);
  return <div className="w-full max-w-4xl mx-auto" data-id="element-70">
      <div className="bg-gradient-to-br from-indigo-900 to-purple-900 rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden min-h-[400px] flex flex-col items-center justify-center" data-id="element-71">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full opacity-20 pointer-events-none" data-id="element-72">
          <div className="absolute top-10 left-10 w-32 h-32 bg-purple-500 rounded-full blur-3xl animate-pulse" data-id="element-73" />
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-blue-500 rounded-full blur-3xl animate-pulse delay-700" data-id="element-74" />
        </div>

        {/* Visualizer Bars (Mock) */}
        <div className="flex items-end justify-center space-x-2 h-32 mb-12 w-full max-w-lg" data-id="element-75">
          {[...Array(20)].map((_, i) => <div key={i} className="w-3 bg-white/40 rounded-t-full transition-all duration-100 ease-in-out" style={{
          height: isPlaying ? `${Math.random() * 100}%` : '20%',
          opacity: isPlaying ? 1 : 0.3
        }} data-id="element-76" />)}
        </div>

        {/* Lyrics Display */}
        <div className="text-center z-10 space-y-4 mb-12" data-id="element-77">
          {poem.content.map((line, index) => {
          // Simple logic to highlight current line based on progress
          const lineProgressStart = index * 25;
          const lineProgressEnd = (index + 1) * 25;
          const isCurrentLine = progress >= lineProgressStart && progress < lineProgressEnd;
          return <p key={index} className={`text-2xl md:text-4xl font-serif transition-all duration-500 ${isCurrentLine ? 'text-white scale-110 font-bold text-shadow-lg' : 'text-white/30 scale-100'}`} data-id="element-78">
                {line}
              </p>;
        })}
        </div>

        {/* Controls */}
        <div className="flex items-center space-x-8 z-10" data-id="element-79">
          <button onClick={() => {
          setIsPlaying(false);
          setProgress(0);
        }} className="p-4 rounded-full bg-white/10 hover:bg-white/20 transition-colors" data-id="element-80">
            <RefreshCw className="w-6 h-6" data-id="element-81" />
          </button>

          <button onClick={() => setIsPlaying(!isPlaying)} className="w-20 h-20 bg-white text-indigo-900 rounded-full flex items-center justify-center hover:scale-105 transition-transform shadow-lg shadow-indigo-500/30" data-id="element-82">
            {isPlaying ? <Pause className="w-8 h-8 fill-current" data-id="element-83" /> : <Play className="w-8 h-8 fill-current ml-1" data-id="element-84" />}
          </button>
        </div>

        {/* Progress Bar */}
        <div className="absolute bottom-0 left-0 w-full h-2 bg-white/10" data-id="element-85">
          <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 transition-all duration-100" style={{
          width: `${progress}%`
        }} data-id="element-86" />
        </div>
      </div>
    </div>;
}